module.exports = __webpack_public_path__ + "img/Dedicated-account-management-team.f97408d9.svg";